"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiFormLabelOverrides = function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        root: __assign(__assign({}, typography.button), { color: palette.text.primary, lineHeight: 1, "&$focused": {
                color: undefined,
            }, "&$error": {
                color: undefined,
            }, "&$disabled": {
                color: undefined,
                opacity: palette.action.disabledOpacity,
            } }),
    });
};
//# sourceMappingURL=MuiFormLabel.js.map